module.exports = __webpack_public_path__ + "static/media/image-cel.b551d8eb.png";